import { PalmettoButton, PalmettoButtonProps } from '@palmetto/dsm-components';
import { MouseEventHandler } from 'react';
import { useNavigation } from '../../hooks/useNavigation';
import { RouteTransitionAnimation } from '../../hooks/useNavigation';
import { trackClick } from '../../tracking/Tracking';

interface BaseProps {
  trackingId: string;
  trackingProperties?: Record<string, unknown>;
}

export type ButtonProps = BaseProps &
  Omit<PalmettoButtonProps, 'onClick'> & {
    onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> | (() => void);
    routeTransitionAnimation?: RouteTransitionAnimation;
  };

export const Button = (props: ButtonProps) => {
  const { children, trackingId, onClick: onClickProp, routeTransitionAnimation, ...restProps } = props;
  const { openURL } = useNavigation();

  const onClick: MouseEventHandler<HTMLAnchorElement> & MouseEventHandler<HTMLButtonElement> & (() => void) = (
    e?: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement> | undefined,
  ) => {
    trackClick(props.trackingId, 'button', {
      href: props.href,
      type: props.type,
      page: window.location.href,
      ...props.trackingProperties,
    });

    if (props.as === 'a' && props.href) {
      e?.preventDefault();
      if (onClickProp) {
        onClickProp(e as React.MouseEvent<HTMLAnchorElement>);
      }
      openURL(props.href, routeTransitionAnimation);
    } else if (onClickProp) {
      onClickProp(e as React.MouseEvent<HTMLButtonElement>);
    }
  };

  return (
    <PalmettoButton {...restProps} data-tracking-id={trackingId} onClick={onClick}>
      {children}
    </PalmettoButton>
  );
};
